import { Directive, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { Component, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { WebSocketService } from '../websockets/websocket.service';
import { EcareConfigurationService } from '../services/ecareconfiguration.service';
import { SensorDataService } from '../services/sensordata.service';
import { ChartOffsetCalculator } from '../services/chartoffsetcalculator.service';
import { UserPreferenceService } from '../services/user.preferences.service';
import { SensorDataConverter } from '../services/sensordataconverter.service';
import { SharedService } from '../../shared.service';
import { Chart } from 'chart.js';

@Directive({
  selector: 'live-chart',
  exportAs: 'live-chart'
})
export class LiveChartDirective{
  @Input() dataLoaded: boolean = false;
  @Input() dataStream: any = '';
  @Input() pollingInterval: string = '';
  @Input() timeRange: string = '';
  @Input() drawMode: string = '';
  @Input() fullscreen: string = '';
  @Input() zoom: string = '';
  @Input() timeoffset: any;


  uniqueId: any = 1;
  lastChannelValues = [];
	lastAnalyticsEventsCount = 0;
	_chart = null;
	chartRows = [];
	series = [];
	analyticsEvents = [];
	subscriptions = {
			sensorData: null,
			analyticsEvents: null
	};
	lastDataTimestamp = moment().toDate().getTime(); //now
	isScheduledExecutorRunning = false;
	uiPreferences = [];
	uiUOM = {};
	timeOffset = 0; //milliseconds
	maxTimeOffset = 30; //seconds
	maxNoDataPeriod = 30; //seconds
	warnings = {
			noRecentData: false,
			offsetLimitExceeded: false
	};
	settings = {}

  chart = [];
  currentUser: string = "";
  selectedUser: string = '';

  constructor(private webSocketService: WebSocketService
    ,private configurationService: EcareConfigurationService
    ,private sensorDataService: SensorDataService
    ,private chartOffsetCalculator: ChartOffsetCalculator
    ,private UserPreferences: UserPreferenceService
    ,private sensorDataConverter: SensorDataConverter,
    private pagedata: SharedService,
    private el: ElementRef) {
      console.log("Directive constructor = "+ this.dataLoaded)
      this.currentUser = JSON.parse(localStorage.getItem("user"));
      this.selectedUser = this.pagedata.get('sensor-data').selectedUser;
      setTimeout(() => {
        console.log("Directive constructor onInit");
        if(this.dataStream.dataStreamType.id == 'TEMPERATURE'){
    					this.UserPreferences.getForLoggedUser('units_measurement_temperature', this.selectedUser).
    						subscribe(
                  response => {
    							this.uiUOM['TEMPERATURE'] = response.units_measurement_temperature || '°C';
    						});

    	   }
        this.initChart(this.drawMode, this.timeRange, this.zoom, this.dataStream, this.timeOffset);
      }, 10000);

      if(!this.dataStream) {
					return;
			}
      this.initPreferences();


  }

  initChart(drawMode, timeRange, zoom, dataStream, timeOffset) {
    this.uniqueId = 'live-chart-' ;
    if(this._chart) {
			this._chart.destroy();
			this.chartRows.length = 0; //clear chart rows
			this._chart = null; //added
  	}
    this.subscribe();
  }


  initPreferences(){
    console.log("In initpref .  ..");
    console.log(this.dataStream);
		this.configurationService.getConfiguration("sensorData/" + this.dataStream.dataStreamType.category + "/channels")
    .subscribe(
          response => {
          	let config = response;
            console.log("Printing config . . . . . ")
            console.log(config)
			      // config.forEach(function(response){
				    //   this.uiPreferences[response.id] = response;
			      // });
            this.uiPreferences = response;
          },err => {
            console.error("Can not get configuration");
          });
    }

    subscribe(){
      let sensorDataTopic = "/dataStream/" + this.dataStream.id;
      this.webSocketService.connect();
    }
}
